
import React from 'react';
import { FormField } from '@/components/ui/form';
import TermsCheckbox from '@/components/auth/TermsCheckbox';
import SubmitButton from '@/components/auth/SubmitButton';
import { UseFormReturn } from 'react-hook-form';
import { SaasSignupFormValues } from '@/schemas/saasSignupSchema';

interface SignupFormFooterProps {
  form: UseFormReturn<SaasSignupFormValues & { captcha: string }>;
  isLoading: boolean;
}

const SignupFormFooter = ({ form, isLoading }: SignupFormFooterProps) => {
  return (
    <>
      <FormField
        control={form.control}
        name="terms"
        render={({ field }) => (
          <TermsCheckbox field={field} />
        )}
      />
      
      <SubmitButton 
        isLoading={isLoading}
        text="Create Business Account"
        loadingText="Creating Account..."
      />
    </>
  );
};

export default SignupFormFooter;
